import React from 'react';
import { FaSyringe, FaTooth } from 'react-icons/fa';

const Card = ({ title, subtitle, Icon, iconColor, onClick, cardClass }) => (
  <button className={`menu-card ${cardClass || ''}`} onClick={onClick}>
    <div className="menu-icon" aria-hidden>
      <Icon className={`size-8 ${iconColor}`} />
    </div>
    <div className="menu-title">{title}</div>
    {subtitle && <div className="menu-subtitle">{subtitle}</div>}
  </button>
);

const ComplicationsMenu = ({ goBack, toOutcomes, toSettings, logout, onSelect }) => {
  return (
    <div className="menu-screen">
      <h1 className="menu-heading">Complication Report</h1>
      <p className="menu-sub">Select the type of complication to report</p>
      <div className="menu-grid three-cols">
        <Card 
          title="Anesthesia Complications" 
          subtitle="Report anesthesia-related complications and adverse events" 
          Icon={FaSyringe} 
          iconColor="text-blue-600"
          onClick={() => onSelect('Anesthesia')} 
          cardClass="clinical" 
        />
        <Card 
          title="Dental Implant Complications" 
          subtitle="Report complications related to implant procedures" 
          Icon={FaTooth} 
          iconColor="text-orange-600"
          onClick={() => onSelect('Dental Implant')} 
          cardClass="clinical" 
        />
        <Card 
          title="Dentoalveolar Surgery Complications" 
          subtitle="Report complications from extractions and surgical procedures" 
          Icon={FaTooth} 
          iconColor="text-orange-600"
          onClick={() => onSelect('Dentoalveolar Surgery')} 
          cardClass="clinical" 
        />
        <Card 
          title="Needle Stick Injury" 
          subtitle="Report needle stick injuries and exposure incidents" 
          Icon={FaSyringe} 
          iconColor="text-red-600"
          onClick={() => onSelect('Needle Stick Injury')} 
          cardClass="clinical" 
        />
      </div>
    </div>
  );
};

export default ComplicationsMenu;
